/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Division } from '../models/Division';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DivisionService {
    /**
     * Get Divisions
     * @returns Division Successful Response
     * @throws ApiError
     */
    public static getDivisionsDivisionGet(): CancelablePromise<Array<Division>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/division/',
        });
    }
}
